import Router from "../src/routes/Router";
import React from "react";

function App() {
    return (
        <div className="w-screen h-screen bg-[#06287D] z-[0]">
            <div className="backgroundDashboard h-screen w-screen fixed top-0 left-0 z-[1]"></div>
            <Router />
        </div>
    );
}

export default App;
